import React from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";
import "./styles.scss";

export default function MapContainer(props) {
  const { currentLocation, setCurrentLocationInput, isMobile } = props;

  return (
    <div className="d-flex justify-content-center mb-3">
      <GoogleMap
        zoom={isMobile ? 15 : 16}
        initialCenter={{
          lat: currentLocation.lat,
          lng: currentLocation.long,
        }}
        center={{
          lat: currentLocation.lat,
          lng: currentLocation.long,
        }}
        mapContainerStyle={
          isMobile
            ? {
                position: "relative",
                width: "100vw",
                height: "70vw",
                border: "5px solid #eca829",
                borderRadius: "1rem",
              }
            : {
                position: "relative",
                width: "57.5vw",
                height: "25vw",
                border: "5px solid #eca829",
                borderRadius: "1rem",
              }
        }
      >
        <Marker
          draggable={true}
          position={{
            lat: currentLocation.lat,
            lng: currentLocation.long,
          }}
          onDragEnd={(e) =>
            setCurrentLocationInput({
              lat: e.latLng.lat(),
              long: e.latLng.lng(),
            })
          }
        />
      </GoogleMap>
    </div>
  );
}
